module.exports = __webpack_public_path__ + "static/media/rne-verso.287ad19c.svg";